import { render, staticRenderFns } from "./InventoryTemplate.vue?vue&type=template&id=6268a592&scoped=true&"
import script from "./InventoryTemplate.vue?vue&type=script&lang=js&"
export * from "./InventoryTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6268a592",
  null
  
)

export default component.exports